// components/Shared/PlatformSettingsPanel/PlatformSettingsPanel.js
import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';
import EmojiPicker from 'emoji-picker-react';
import QuickButtonSelector from '../../Modals/ContentModal/components/QuickButtonSelector';
import './PlatformSettingsPanel.css';

// Platform SVG Icons
const PlatformIcons = {
  telegram: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
    </svg>
  ),
  youtube: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  ),
  x: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  ),
  tiktok: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  ),
  instagram: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
    </svg>
  )
};

const PLATFORM_COLORS = {
  telegram: '#2AABEE',
  youtube: '#FF0000',
  x: '#ffffff',
  tiktok: '#ff0050',
  instagram: '#E4405F'
};

const YOUTUBE_CATEGORIES = [
  { id: '1', name: 'Film ve Animasyon' },
  { id: '2', name: 'Otomobiller ve Araclar' },
  { id: '10', name: 'Muzik' },
  { id: '15', name: 'Evcil Hayvanlar' },
  { id: '17', name: 'Spor' },
  { id: '19', name: 'Seyahat ve Etkinlikler' },
  { id: '20', name: 'Oyun' },
  { id: '22', name: 'Insanlar ve Bloglar' },
  { id: '23', name: 'Komedi' },
  { id: '24', name: 'Eglence' },
  { id: '25', name: 'Haberler ve Politika' },
  { id: '26', name: 'Nasil Yapilir ve Stil' },
  { id: '27', name: 'Egitim' },
  { id: '28', name: 'Bilim ve Teknoloji' }
];

const PlatformSettingsPanel = ({
  // Telegram
  contentText = '',
  onContentTextChange,
  buttonForm = [],
  onButtonFormChange,
  showEmojiPicker = false,
  onToggleEmojiPicker,

  // YouTube
  youtubeSettings = {},
  onYoutubeSettingsChange,

  // X (Twitter)
  xSettings = {},
  onXSettingsChange,

  // TikTok
  tiktokSettings = {},
  onTiktokSettingsChange,

  // Instagram
  instagramSettings = {},
  onInstagramSettingsChange,

  // Genel
  hasVideo = false,
  hasPhoto = false,
  videoDuration = null,
  bulkMode = false,
  selectedTagIds = [],
  tags = [],
  compact = false
}) => {
  const [expandedPlatform, setExpandedPlatform] = useState(null);
  const [isButtonsExpanded, setIsButtonsExpanded] = useState(false);
  const [currentButton, setCurrentButton] = useState(null);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [linkData, setLinkData] = useState({ text: '', url: '' });
  const [localShowEmojiPicker, setLocalShowEmojiPicker] = useState(false);

  // Context Menu
  const [contextMenu, setContextMenu] = useState({
    visible: false, x: 0, y: 0, selectedText: '', selectionStart: 0, selectionEnd: 0
  });
  const textareaRef = useRef(null);
  const contextMenuRef = useRef(null);

  // YouTube local form
  const [localYoutubeForm, setLocalYoutubeForm] = useState({
    title: youtubeSettings.title || '',
    description: youtubeSettings.description || '',
    categoryId: youtubeSettings.categoryId || '24'
  });

  const videoType = videoDuration ? (videoDuration <= 60 ? 'shorts' : 'video') : null;

  // Girls tag check
  const hasGirlsTag = tags.some(tag =>
    selectedTagIds.includes(tag.id) &&
    tag.name.toLowerCase().includes('girls')
  );

  // Sync YouTube settings
  useEffect(() => {
    if (onYoutubeSettingsChange) {
      onYoutubeSettingsChange({
        ...youtubeSettings,
        title: localYoutubeForm.title,
        description: localYoutubeForm.description,
        categoryId: localYoutubeForm.categoryId
      });
    }
  }, [localYoutubeForm]);

  // Context menu outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
        setContextMenu(prev => ({ ...prev, visible: false }));
      }
    };
    if (contextMenu.visible) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [contextMenu.visible]);

  // Platform visibility
  const getVisiblePlatforms = () => {
    const all = [
      { id: 'telegram', name: 'Telegram', desc: 'Kanal icerigi ve butonlar' },
      { id: 'youtube', name: 'YouTube', desc: 'Shorts ve Video yukleme' },
      { id: 'x', name: 'X (Twitter)', desc: 'Tweet paylasimi (280 karakter)' },
      { id: 'tiktok', name: 'TikTok', desc: 'Video paylasimi' },
      { id: 'instagram', name: 'Instagram', desc: 'Post, Reels ve Story' }
    ];

    if (bulkMode) return all;

    return all.filter(p => {
      if (p.id === 'youtube' || p.id === 'tiktok') {
        return hasVideo && !hasPhoto;
      }
      return true;
    });
  };

  // Toggle platform
  const handlePlatformToggle = (platformId) => {
    if (expandedPlatform === platformId) {
      setExpandedPlatform(null);
    } else {
      setExpandedPlatform(platformId);
    }
  };

  // Context menu
  const handleContextMenu = (e) => {
    e.preventDefault();
    const textarea = textareaRef.current;
    if (!textarea) return;
    const selectedText = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
    if (!selectedText) { setContextMenu(prev => ({ ...prev, visible: false })); return; }
    setContextMenu({
      visible: true, x: e.clientX, y: e.clientY,
      selectedText, selectionStart: textarea.selectionStart, selectionEnd: textarea.selectionEnd
    });
  };

  const applyFormatting = (formatType) => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    const { selectionStart, selectionEnd, selectedText } = contextMenu;
    const content = contentText || '';
    let formattedText = '';

    const formats = {
      bold: { open: '<b>', close: '</b>' },
      italic: { open: '<i>', close: '</i>' },
      code: { open: '<code>', close: '</code>' },
      strikethrough: { open: '<s>', close: '</s>' },
      underline: { open: '<u>', close: '</u>' },
      spoiler: { open: '<tg-spoiler>', close: '</tg-spoiler>' },
      monospace: { open: '<pre>', close: '</pre>' }
    };

    const fmt = formats[formatType];
    if (!fmt) return;
    formattedText = `${fmt.open}${selectedText}${fmt.close}`;

    const newContent = content.substring(0, selectionStart) + formattedText + content.substring(selectionEnd);
    if (onContentTextChange) onContentTextChange(newContent);
    setContextMenu(prev => ({ ...prev, visible: false }));
    toast.success('Biçimlendirme uygulandı');
  };

  // Emoji
  const handleEmojiClick = (emojiObject) => {
    const newContent = (contentText || '') + emojiObject.emoji;
    if (onContentTextChange) onContentTextChange(newContent);
    setLocalShowEmojiPicker(false);
    if (onToggleEmojiPicker) onToggleEmojiPicker(false);
  };

  // Link
  const handleInsertLink = () => {
    if (!linkData.text || !linkData.url) { toast.error('Metin ve URL zorunludur'); return; }
    const link = `[${linkData.text}](${linkData.url})`;
    const newContent = (contentText || '') + link;
    if (onContentTextChange) onContentTextChange(newContent);
    setShowLinkModal(false);
    setLinkData({ text: '', url: '' });
    toast.success('Link eklendi');
  };

  // Quick button
  const handleQuickButtonAdd = (button) => {
    const newButtonForm = Array.isArray(buttonForm) ? [...buttonForm] : [];
    if (newButtonForm.length === 0 || !Array.isArray(newButtonForm[newButtonForm.length - 1])) {
      newButtonForm.push([]);
    }
    const lastRow = newButtonForm[newButtonForm.length - 1];
    if (lastRow.length < 3) { lastRow.push(button); }
    else { newButtonForm.push([button]); }
    if (onButtonFormChange) onButtonFormChange(newButtonForm);
  };

  const handleRemoveButton = (rowIndex, buttonIndex) => {
    const newButtonForm = [...buttonForm];
    newButtonForm[rowIndex].splice(buttonIndex, 1);
    if (newButtonForm[rowIndex].length === 0) newButtonForm.splice(rowIndex, 1);
    if (onButtonFormChange) onButtonFormChange(newButtonForm);
    toast.success('Buton silindi');
  };

  // Formatting labels
  const formatLabels = [
    { type: 'bold', icon: 'B', label: 'Kalin', tag: '<b>' },
    { type: 'italic', icon: 'I', label: 'Italik', tag: '<i>' },
    { type: 'code', icon: '</>', label: 'Kod', tag: '<code>' },
    { type: 'strikethrough', icon: 'S', label: 'Ustu Cizili', tag: '<s>' },
    { type: 'underline', icon: 'U', label: 'Alt Cizili', tag: '<u>' },
    { type: 'spoiler', icon: '?', label: 'Spoiler', tag: '<tg-spoiler>' },
    { type: 'monospace', icon: 'M', label: 'Monospace', tag: '<pre>' }
  ];

  // ─── RENDERERS ─────────────────────────────────────────

  const renderTelegram = () => (
    <div className="psp-platform-body">
      {/* Content Text */}
      <div className="psp-field">
        <div className="psp-field-header">
          <label>Icerik Metni</label>
          <div className="psp-toolbar">
            <button type="button" className="psp-tool-btn" onClick={() => setLocalShowEmojiPicker(!localShowEmojiPicker)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>
              <span>Emoji</span>
            </button>
            <button type="button" className="psp-tool-btn" onClick={() => setShowLinkModal(true)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
              <span>Link</span>
            </button>
            <span className="psp-char-indicator">{(contentText || '').length} / 4096</span>
          </div>
        </div>

        <div className="psp-formatting-tip">
          Metni secip sag tiklayarak Telegram bicimlendirilmesi yapabilirsiniz
        </div>

        <div className="psp-textarea-wrap">
          {contentText && /\[([^\]]+)\]\(([^)]+)\)/.test(contentText) && (
            <div className="psp-richtext-overlay" dangerouslySetInnerHTML={{
              __html: (() => {
                let text = contentText || '';
                text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a class="psp-inline-link" title="$2">$1</a>');
                text = text.replace(/\n/g, '<br>');
                return text;
              })()
            }} />
          )}
          <textarea
            ref={textareaRef}
            value={contentText || ''}
            onChange={(e) => onContentTextChange && onContentTextChange(e.target.value)}
            onContextMenu={handleContextMenu}
            placeholder="Telegram'da paylasilacak icerik metni..."
            rows={6}
            maxLength={4096}
            className={contentText && /\[([^\]]+)\]\(([^)]+)\)/.test(contentText) ? 'has-links' : ''}
          />
        </div>

        {/* Context Menu */}
        {contextMenu.visible && (
          <div ref={contextMenuRef} className="psp-context-menu" style={{ position: 'fixed', left: `${contextMenu.x}px`, top: `${contextMenu.y}px`, zIndex: 10000 }}>
            {formatLabels.map(f => (
              <button key={f.type} type="button" onClick={() => applyFormatting(f.type)} className="psp-context-item">
                <span className="psp-ctx-icon">{f.icon}</span>
                <span className="psp-ctx-label">{f.label}</span>
                <span className="psp-ctx-tag">{f.tag}</span>
              </button>
            ))}
          </div>
        )}

        {/* Emoji Picker */}
        {localShowEmojiPicker && (
          <>
            <div className="psp-emoji-overlay" onClick={() => setLocalShowEmojiPicker(false)} />
            <div className="psp-emoji-picker">
              <EmojiPicker onEmojiClick={handleEmojiClick} searchPlaceHolder="" width={350} height={400} previewConfig={{ showPreview: false }} />
            </div>
          </>
        )}
      </div>

      {/* Buttons Preview */}
      {buttonForm && buttonForm.length > 0 && (
        <div className="psp-telegram-buttons">
          {buttonForm.map((row, rowIndex) => (
            <div key={rowIndex} className="psp-tg-btn-row">
              {Array.isArray(row) ? row.map((button, btnIndex) => (
                <div key={btnIndex} className="psp-tg-btn">
                  <span>{button.text}</span>
                  <button type="button" onClick={() => handleRemoveButton(rowIndex, btnIndex)} className="psp-tg-btn-remove">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </button>
                </div>
              )) : (
                <div className="psp-tg-btn">
                  <span>{row.text}</span>
                  <button type="button" onClick={() => handleRemoveButton(rowIndex, 0)} className="psp-tg-btn-remove">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Quick Button Selector */}
      <div className="psp-btn-selector">
        <QuickButtonSelector
          onButtonAdd={handleQuickButtonAdd}
          currentButton={currentButton}
          setCurrentButton={setCurrentButton}
          showAddForm={isButtonsExpanded}
        />
      </div>
    </div>
  );

  const renderYouTube = () => {
    const isShortsEnabled = bulkMode || videoType === 'shorts';
    const isVideoEnabled = bulkMode || videoType === 'video';

    return (
      <div className="psp-platform-body">
        {videoDuration && (
          <div className="psp-info-banner">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>
            <span>Video suresi: <strong>{videoDuration}s</strong> {isShortsEnabled ? '- Shorts icin uygun' : '- Normal Video'}</span>
          </div>
        )}

        {/* Shorts / Video Section */}
        <div className={`psp-yt-section ${!isShortsEnabled && !isVideoEnabled ? 'disabled' : ''}`}>
          <div className="psp-yt-section-label">
            {isShortsEnabled ? 'YouTube Shorts' : isVideoEnabled ? 'YouTube Video' : 'YouTube'}
          </div>

          <div className="psp-field">
            <label>{isShortsEnabled ? 'Shorts Basligi' : 'Video Basligi'}</label>
            <input
              type="text"
              value={localYoutubeForm.title}
              onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, title: e.target.value }))}
              placeholder="YouTube basligi (max 100 karakter)"
              maxLength={100}
            />
            <span className="psp-hint">{localYoutubeForm.title.length}/100</span>
          </div>

          <div className="psp-field">
            <label>Aciklama</label>
            <textarea
              value={localYoutubeForm.description}
              onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, description: e.target.value }))}
              placeholder="Video aciklamasi (opsiyonel)"
              rows={3}
              maxLength={5000}
            />
            <span className="psp-hint">{localYoutubeForm.description.length}/5000</span>
          </div>

          <div className="psp-field">
            <label>Kategori</label>
            <select value={localYoutubeForm.categoryId} onChange={(e) => setLocalYoutubeForm(prev => ({ ...prev, categoryId: e.target.value }))}>
              {YOUTUBE_CATEGORIES.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
            </select>
          </div>
        </div>

        <div className="psp-info-banner psp-info-muted">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          <span>Tum YouTube videolari "Herkese Acik" olarak yuklenecektir.</span>
        </div>
      </div>
    );
  };

  const renderX = () => {
    const charCount = (xSettings.text || '').length;

    return (
      <div className="psp-platform-body">
        <div className="psp-field">
          <div className="psp-field-header">
            <label>Tweet Metni</label>
            <span className={`psp-char-indicator ${charCount > 260 ? 'warning' : ''}`}>{charCount} / 280</span>
          </div>
          <textarea
            value={xSettings.text || ''}
            onChange={(e) => {
              if (e.target.value.length <= 280) {
                onXSettingsChange && onXSettingsChange({ ...xSettings, text: e.target.value, useOriginal: false, charCount: e.target.value.length });
              } else {
                toast.warning('Tweet 280 karakterden uzun olamaz');
              }
            }}
            placeholder={hasGirlsTag ? 'Bos birakirsaniz orijinal icerik metni kullanilir' : 'Tweet metninizi yazin (max 280 karakter)'}
            rows={4}
            maxLength={280}
            className={charCount > 260 ? 'near-limit' : ''}
          />
          <div className="psp-field-footer">
            {hasGirlsTag
              ? 'Bos birakirsaniz orijinal icerik metni kullanilir (280 karaktere kisaltilarak)'
              : 'Bos birakirsaniz metin bos olarak paylasilir'}
          </div>
        </div>
      </div>
    );
  };

  const renderTikTok = () => (
    <div className="psp-platform-body">
      <div className="psp-field">
        <div className="psp-field-header">
          <label>Video Aciklamasi</label>
          <span className="psp-char-indicator">{(tiktokSettings?.caption || '').length} / 2200</span>
        </div>
        <textarea
          value={tiktokSettings?.caption || ''}
          onChange={(e) => {
            if (e.target.value.length <= 2200) {
              onTiktokSettingsChange && onTiktokSettingsChange({ ...tiktokSettings, caption: e.target.value });
            }
          }}
          placeholder={hasGirlsTag ? 'Bos birakirsaniz orijinal icerik metni kullanilir' : 'TikTok video aciklamasi'}
          rows={3}
          maxLength={2200}
        />
        <div className="psp-field-footer">
          {hasGirlsTag ? 'Bos birakirsaniz orijinal icerik metni kullanilir' : 'Bos birakirsaniz bos metin paylasilir'}
        </div>
      </div>

      <div className="psp-field">
        <label>Hashtag'ler</label>
        <input
          type="text"
          value={tiktokSettings?.hashtags || ''}
          onChange={(e) => onTiktokSettingsChange && onTiktokSettingsChange({ ...tiktokSettings, hashtags: e.target.value })}
          placeholder="#trending #viral #fyp"
        />
        <span className="psp-hint">Hashtag'leri boslukla ayirin</span>
      </div>

      <div className="psp-toggles">
        <label className="psp-toggle-label">
          <input type="checkbox" checked={tiktokSettings?.allowComments !== false}
            onChange={(e) => onTiktokSettingsChange && onTiktokSettingsChange({ ...tiktokSettings, allowComments: e.target.checked })} />
          <span className="psp-toggle-switch"></span>
          <span>Yorumlara izin ver</span>
        </label>
        <label className="psp-toggle-label">
          <input type="checkbox" checked={tiktokSettings?.allowDuet !== false}
            onChange={(e) => onTiktokSettingsChange && onTiktokSettingsChange({ ...tiktokSettings, allowDuet: e.target.checked })} />
          <span className="psp-toggle-switch"></span>
          <span>Duet ve Stitch'e izin ver</span>
        </label>
      </div>

      {videoDuration && (
        <div className="psp-info-banner">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>
          <span>Video suresi: <strong>{videoDuration}s</strong> {videoDuration <= 60 ? '- TikTok icin ideal' : videoDuration > 180 ? '- Maksimum 3 dakika olmali' : ''}</span>
        </div>
      )}
    </div>
  );

  const renderInstagram = () => {
    const getDefaultContentType = () => {
      if (hasVideo && !hasPhoto) return 'reel';
      return 'post';
    };

    const settings = instagramSettings || { contentType: getDefaultContentType(), caption: '', firstComment: '', collaborators: '', userTags: '' };

    return (
      <div className="psp-platform-body">
        {/* Content Type */}
        <div className="psp-field">
          <label>Paylasilm Tipi</label>
          <div className="psp-content-types">
            {[
              { id: 'post', label: 'Post', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>, disabled: !bulkMode && !hasPhoto && hasVideo },
              { id: 'reel', label: 'Reels', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>, disabled: !bulkMode && !hasVideo },
              { id: 'story', label: 'Story', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>, disabled: false }
            ].map(type => (
              <button
                key={type.id}
                type="button"
                className={`psp-type-btn ${settings.contentType === type.id ? 'active' : ''} ${type.disabled ? 'disabled' : ''}`}
                onClick={() => !type.disabled && onInstagramSettingsChange && onInstagramSettingsChange({ ...settings, contentType: type.id })}
                disabled={type.disabled}
              >
                {type.icon}
                <span>{type.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Caption */}
        <div className="psp-field">
          <div className="psp-field-header">
            <label>{settings.contentType === 'story' ? 'Story Metni' : 'Aciklama'}</label>
            <span className="psp-char-indicator">{(settings.caption || '').length} / 2200</span>
          </div>
          <textarea
            value={settings.caption || ''}
            onChange={(e) => {
              if (e.target.value.length <= 2200) {
                onInstagramSettingsChange && onInstagramSettingsChange({ ...settings, caption: e.target.value });
              }
            }}
            placeholder={hasGirlsTag ? 'Bos birakirsaniz orijinal icerik metni kullanilir' : 'Instagram aciklamasi'}
            rows={3}
            maxLength={2200}
          />
          <div className="psp-field-footer">
            {hasGirlsTag ? 'Bos birakirsaniz orijinal icerik metni kullanilir' : 'Bos birakirsaniz metinsiz paylasilir'}
          </div>
        </div>

        {/* Advanced - not for Story */}
        {settings.contentType !== 'story' && (
          <>
            <div className="psp-field">
              <label>Ilk Yorum (Opsiyonel)</label>
              <input
                type="text"
                value={settings.firstComment || ''}
                onChange={(e) => onInstagramSettingsChange && onInstagramSettingsChange({ ...settings, firstComment: e.target.value })}
                placeholder="Gonderiye otomatik ilk yorum ekle..."
                maxLength={2200}
              />
              <span className="psp-hint">Link ve CTA icin ideal</span>
            </div>

            {(settings.contentType === 'post' || settings.contentType === 'reel') && (
              <div className="psp-field">
                <label>Isbirlikciler (Max 3)</label>
                <input
                  type="text"
                  value={settings.collaborators || ''}
                  onChange={(e) => onInstagramSettingsChange && onInstagramSettingsChange({ ...settings, collaborators: e.target.value })}
                  placeholder="@kullanici1, @kullanici2, @kullanici3"
                />
                <span className="psp-hint">Virgülle ayirin</span>
              </div>
            )}

            {settings.contentType === 'post' && hasPhoto && (
              <div className="psp-field">
                <label>Kisi Etiketle</label>
                <input
                  type="text"
                  value={settings.userTags || ''}
                  onChange={(e) => onInstagramSettingsChange && onInstagramSettingsChange({ ...settings, userTags: e.target.value })}
                  placeholder="@kullanici1, @kullanici2"
                />
                <span className="psp-hint">Fotografta etiketlenecek kisiler</span>
              </div>
            )}
          </>
        )}

        {settings.contentType === 'reel' && videoDuration && (
          <div className="psp-info-banner">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>
            <span>Video suresi: <strong>{videoDuration}s</strong> {videoDuration <= 90 ? '- Reels icin uygun' : '- Maksimum 90 saniye olmali'}</span>
          </div>
        )}

        {settings.contentType === 'story' && (
          <div className="psp-info-banner psp-info-warning">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Story'ler 24 saat sonra otomatik olarak silinir</span>
          </div>
        )}
      </div>
    );
  };

  const renderPlatformContent = (platformId) => {
    switch (platformId) {
      case 'telegram': return renderTelegram();
      case 'youtube': return renderYouTube();
      case 'x': return renderX();
      case 'tiktok': return renderTikTok();
      case 'instagram': return renderInstagram();
      default: return null;
    }
  };

  // ─── MAIN RENDER ───────────────────────────────────────

  const visiblePlatforms = getVisiblePlatforms();

  return (
    <div className={`psp-container ${compact ? 'psp-compact' : ''}`}>
      <div className="psp-header">
        <div className="psp-header-line" />
        <h4 className="psp-title">Platform Ayarlari</h4>
        <div className="psp-header-line" />
      </div>

      <div className="psp-platforms">
        {visiblePlatforms.map(platform => {
          const isExpanded = expandedPlatform === platform.id;
          const color = PLATFORM_COLORS[platform.id];

          return (
            <div key={platform.id} className={`psp-platform ${isExpanded ? 'expanded' : ''}`} style={{ '--platform-accent': color }}>
              {/* Platform Header */}
              <div className="psp-platform-header" onClick={() => handlePlatformToggle(platform.id)}>
                <div className="psp-platform-left">
                  <div className="psp-platform-icon">
                    {PlatformIcons[platform.id]}
                  </div>
                  <div className="psp-platform-meta">
                    <span className="psp-platform-name">{platform.name}</span>
                    <span className="psp-platform-desc">{platform.desc}</span>
                  </div>
                </div>
                <div className="psp-platform-right">
                  {platform.id === 'telegram' && isExpanded && (
                    <button
                      type="button"
                      className="psp-add-btn"
                      onClick={(e) => { e.stopPropagation(); setIsButtonsExpanded(!isButtonsExpanded); }}
                    >
                      + Buton Ekle
                    </button>
                  )}
                  <div className={`psp-chevron ${isExpanded ? 'open' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Platform Body */}
              <div className={`psp-platform-content ${isExpanded ? 'visible' : ''}`}>
                {isExpanded && renderPlatformContent(platform.id)}
              </div>
            </div>
          );
        })}
      </div>

      {/* Link Modal */}
      {showLinkModal && (
        <div className="psp-modal-overlay" onClick={() => setShowLinkModal(false)}>
          <div className="psp-link-modal" onClick={(e) => e.stopPropagation()}>
            <h4>Link Ekle</h4>
            <input type="text" placeholder="Link metni" value={linkData.text} onChange={(e) => setLinkData({ ...linkData, text: e.target.value })} />
            <input type="url" placeholder="https://example.com" value={linkData.url} onChange={(e) => setLinkData({ ...linkData, url: e.target.value })} />
            <div className="psp-link-actions">
              <button onClick={handleInsertLink} className="psp-link-btn-primary">Ekle</button>
              <button onClick={() => setShowLinkModal(false)} className="psp-link-btn-secondary">Iptal</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlatformSettingsPanel;